import React from "react";
import "./Constructiondebris.css";
import { FiTrash } from "react-icons/fi";
import junk from "../../Assests/gallery2.webp";

const Constructiondebris = () => {
  return (
    <section className="Constructiondebris-section">
      <div className="Constructiondebris-container">
        {/* Content Column */}
        <div className="Constructiondebris-content">
          <div className="content-header">
            <div className="service-icons">
              <FiTrash size={32} />
            </div>
            <h1 className="service-title">
              <span className="title-accent">Construction</span> Debris Removal
            </h1>
          </div>

          <p className="service-description">
            Construction projects leave behind piles of waste—we clear it so your crew can stay
            focused on the build. From demolition debris to leftover materials, we haul it quickly
            and leave a clean, safe site behind. Our team manages heavy loads, awkward scraps, and
            active job sites with precision. No pile is too big and no area is overlooked.
          </p>

          <p className="service-description">
            We remove wood waste, drywall, flooring, roofing debris, and mixed job site clutter such
            as insulation, packaging, and buckets. Count on us for reliable, job-site-ready service
            that keeps your project moving. We work efficiently alongside contractors to avoid delays.
            All debris is disposed of responsibly, following local regulations. With our service, you get
            a clear space that’s ready for the next phase of construction.
          </p>

          <div className="cta-group">
            <a
              href="https://app.squareup.com/appointments/book/41vplmwf0luh01/LTHMTFD90TMRT/start"
              className="primary-cta"
              target="_blank"
              rel="noopener noreferrer"
            >
              Schedule Your Pickup
              <span className="cta-arrow">→</span>
            </a>
          </div>
        </div>

        {/* Image Column */}
        <div className="Constructiondebris-image">
          <img
            src={junk}
            alt="Professional construction debris removal team clearing job site"
            className="main-image"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default Constructiondebris;
